import React, { useEffect, useState } from 'react';
import BaseModal from '../utils/BaseModal/BaseModal';
import {
  ButtonWrapper,
  CloseButton,
  Container,
  Footer,
  ListContainer,
  ListItem,
  ListItemColumn,
  ListItemRow,
  LoaderContainer,
  MediaCountRow,
  MediaCountText,
  SoldBundle,
} from './SelectBundleModal.styles';
import { Button } from '../../utils/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { selectFetchMediaBundlesInfo } from '../../../store/slices/user/slice';
import { fetchMediaBundles } from '../../../store/slices/user/asyncThunks';
import Spinner from '../../Spinner/Spinner';
import { Text16Regular } from '../../utils/Text/Text.styles';
import { ReactComponent as ImageIcon } from '../../../assets/icons/image-04.svg';
import { ReactComponent as VideoRecorderIcon } from '../../../assets/icons/video-recorder.svg';
import { ReactComponent as CheckCircleEmptyIcon } from '../../../assets/icons/check-circle-empty.svg';
import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/check-circle-broken.svg';

const SelectBundleModal = ({
  modalRef,
  onAdd,
  reload = true,
  setReload,
  onClose = () => {},
  userInfluencerId,
  influencerId,
}) => {
  const dispatch = useDispatch();
  const [selectedBundle, setSelectedBundle] = useState(null);

  const { data, pending } = useSelector(selectFetchMediaBundlesInfo);

  useEffect(() => {
    if (reload) {
      dispatch(
        fetchMediaBundles({ ...(userInfluencerId && { userInfluencerId }), ...(influencerId && { influencerId }) }),
      );
    }
  }, [dispatch, userInfluencerId, reload, influencerId]);

  return (
    <BaseModal
      title="Bundles"
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
        onClose();
      }}
      onAfterClose={() => {
        setSelectedBundle(null);
        if (setReload) {
          setReload(false);
        }
      }}>
      <Container>
        {pending ? (
          <LoaderContainer>
            <Spinner width={120} height={120} />
          </LoaderContainer>
        ) : (
          <ListContainer>
            {data.map(bundle => {
              return (
                <ListItem
                  key={bundle.id}
                  $disabled={!bundle.aiDescription}
                  $selected={bundle.id === selectedBundle?.id}
                  onClick={() => {
                    if (bundle.aiDescription) {
                      setSelectedBundle(bundle);
                    }
                  }}>
                  <ListItemColumn>
                    <ListItemRow>
                      <Text16Regular>{bundle.name}</Text16Regular>
                      {!bundle.available && <SoldBundle>SOLD</SoldBundle>}
                    </ListItemRow>
                    <ListItemRow>
                      <MediaCountRow>
                        <ImageIcon color="#9DA4AE" height={18} width={18} />
                        <MediaCountText>{bundle.numOfPhotos}</MediaCountText>
                      </MediaCountRow>
                      <MediaCountRow>
                        <VideoRecorderIcon color="#9DA4AE" height={18} width={18} />
                        <MediaCountText>{bundle.numOfVideos}</MediaCountText>
                      </MediaCountRow>
                    </ListItemRow>
                  </ListItemColumn>

                  {bundle.id === selectedBundle?.id ? (
                    <CheckCircleIcon color="#1672BA" width={24} height={24} />
                  ) : (
                    <CheckCircleEmptyIcon color="#1672BA" width={24} height={24} />
                  )}
                </ListItem>
              );
            })}
          </ListContainer>
        )}
        <Footer>
          <CloseButton
            onClick={() => {
              onClose();
              modalRef.current.hide();
            }}>
            Close
          </CloseButton>
          <ButtonWrapper>
            <Button
              title="Add"
              disabled={!selectedBundle}
              onClick={() => {
                onAdd(selectedBundle);
                modalRef.current.hide();
              }}
            />
          </ButtonWrapper>
        </Footer>
      </Container>
    </BaseModal>
  );
};

export default SelectBundleModal;
